import { useCart } from '@hooks/useCart/useCart';
import { deriveCartSummary } from '@utils/cartPricing';
import type { CartSummary } from '@utils/cartPricing';

export const useCartSummary = (sessionId: string): CartSummary => {
  const cartQuery = useCart(sessionId);
  return deriveCartSummary(cartQuery.data);
};
